import React, { useEffect } from 'react'
import styles from './notification.module.scss'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { fetchNotification } from 'actions/users';
import InfiniteScroll from 'react-infinite-scroller';
import defaultAsset from 'images/default_asset.jpg';
import Truncate from 'react-truncate';
import defaultProfileIcon from "images/default_user_profile_background.png";
import _ from 'lodash';
import cx from "classnames";

export default function Notification(props) {
  const history = useHistory();
  const dispatch = useDispatch();

  const profile = useSelector((state) => _.get(state, 'users.profile.item') || null);
  const loading = useSelector((state) => _.get(state, 'users.notification.loading'));
  const items = useSelector((state) => _.get(state, 'users.notification.items')) || [];
  const currentPage = useSelector((state) => _.get(state, 'users.notification.pagination.currentPage'));
  const totalPages = useSelector((state) => _.get(state, 'users.notification.pagination.totalPages'));

  useEffect(() => {
    dispatch(fetchNotification(0))
  }, [])

  const loadMoreItems = () => {
    if (loading) {
      return;
    }

    dispatch(fetchNotification(currentPage + 1));
  }
  

  const handleBackClicked = () => {
    history.push("/paperflite-home")
  }

  return (
    <div className={styles.notificationContainer}>
      <p className={styles.headerContainer}>
        <span className={styles.backButton} onClick={() => handleBackClicked()}>
        <i className="paperflite-left-arrow"/>
        <span className={styles.back}>
        BACK
        </span>
        </span>
      </p>
      <div className={styles.content}>
        <div className={styles.userDetails}>
          <img alt="Profile Icon" className={styles.profileIcon} src={profile ? _.get(profile, "icon.thumbnail") : defaultProfileIcon} />
          <p className={cx(styles.profileName, {[styles.placeholderName] : !profile})}>{profile ? profile.firstName : "name"}</p>
          <p className={cx(styles.profileEmail, {[styles.placeholderEmail]: !profile})}>{profile ? profile.email : "name@gmail.com"}</p>
        </div>
        <div className={styles.innerContainer}>
          <p className={styles.title}>Notifications </p>

          <div className={styles.notifications}>

        {_.size(items) > 0 &&
          ( <InfiniteScroll
              pageStart={0}
              initialLoad={false}
              hasMore={currentPage < totalPages}
              loadMore={() => { loadMoreItems() }}
              useWindow={false}
              threshold={150}
            >
              {items.map((item, i) => <NotificationNode key={i} notification={item} />)}

            </InfiniteScroll>)
            }

            {loading && (
              <span className={styles.loading}>loading notifications...</span>
            )}

            {_.size(items) === 0 && !loading && (
              <span className={styles.empty}>No notifications</span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

const NotificationNode = ({ notification }) => {
  return (
    <a rel="noopener noreferrer" href={notification.url ? notification.url : "#"} target='_blank'>
      <div className={styles.notificationInnerContainer}>
        <img
          alt="group thumbnail"
          src={_.get(notification, "icon.thumbnail") || defaultAsset} />
        <div className={styles.contentContainer}>
          <p className={styles.type}>{notification.title}</p>
          <p className={styles.message}>{notification.message}</p>
        </div>
      </div>
    </a>
  )
}